import { NoDataAvailableComponent } from '@blackhyve/common';
import { Grid } from '@mui/material';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import { selectLocationIds } from '../store/locationsSlice';
import LocationRowComponent from './LocationRowComponent';

const LocationListComponent = ({ projectId }) => {
  const locationIds = useSelector((state) => selectLocationIds(state));
  return (
    <Droppable droppableId={'project-' + projectId} type={'LOCATION-' + projectId}>
      {(provided) => (
        <Grid
          container
          {...provided.droppableProps}
          justifyContent={'center'}
          ref={provided.innerRef}
        >
          {locationIds && locationIds.length > 0 ? (
            locationIds.map((id, index) => {
              return (
                <LocationRowComponent
                  id={id}
                  key={`location-${id}`}
                  locationIndex={index}
                  projectId={projectId}
                />
              );
            })
          ) : (
            <NoDataAvailableComponent />
          )}
          {provided.placeholder}
        </Grid>
      )}
    </Droppable>
  );
};

export default memo(LocationListComponent);
